import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DynamicBodyClass = () => {
  const location = useLocation();

  useEffect(() => {
    const body = document.body;

    // Clear previous class if any
    body.className = '';

    // Add class for specific pages
    if (location.pathname === '/login' || location.pathname === '/register') {
      body.classList.add('auth-page');
    }

    // Optional cleanup when component unmounts
    return () => {
      body.className = '';
    };
  }, [location]);

  return null;
};

export default DynamicBodyClass;
